import mAssemblyTable from './main.vue';

export default mAssemblyTable;
